import { Image as ImageIcon, Camera, Home, Building, Wrench, Palette, Zap, Droplets, Snowflake, Layers } from "lucide-react";

const iconMap = {
  image: ImageIcon,
  camera: Camera,
  home: Home,
  building: Building,
  wrench: Wrench,
  palette: Palette,
  zap: Zap,
  droplets: Droplets,
  snowflake: Snowflake,
  layers: Layers,
};

export default function Placeholder({
  icon = "image",
  label,
  ratio = "4/3",
  variant = "light",
  className = "",
  children,
}) {
  const Icon = iconMap[icon] || ImageIcon;
  const isDark = variant === "dark";
  return (
    <div
      className={`relative w-full ${className} ${isDark ? "placeholder-dark" : "placeholder-block"} border ${isDark ? "border-white/10" : "border-black/10"} overflow-hidden`}
      style={{ aspectRatio: ratio }}
    >
      <div className="absolute inset-0 flex flex-col items-center justify-center gap-3 text-center px-4">
        <Icon
          className={`w-8 h-8 md:w-10 md:h-10 ${isDark ? "text-white/40" : "text-anthracite/30"}`}
          strokeWidth={1.25}
        />
        {label && (
          <div className={`text-[10px] uppercase tracking-[0.3em] ${isDark ? "text-white/50" : "text-anthracite/40"}`}>
            {label}
          </div>
        )}
        {children}
      </div>
      {/* Corner marks — architectural feel */}
      <span className={`absolute top-2 left-2 w-3 h-3 border-t border-l ${isDark ? "border-white/30" : "border-anthracite/30"}`} />
      <span className={`absolute top-2 right-2 w-3 h-3 border-t border-r ${isDark ? "border-white/30" : "border-anthracite/30"}`} />
      <span className={`absolute bottom-2 left-2 w-3 h-3 border-b border-l ${isDark ? "border-white/30" : "border-anthracite/30"}`} />
      <span className={`absolute bottom-2 right-2 w-3 h-3 border-b border-r ${isDark ? "border-white/30" : "border-anthracite/30"}`} />
    </div>
  );
}
